export default "__VITE_ASSET__Bmkvrn7u__"